import styled from 'styled-components/macro';

import Box from 'components/elements/Box';
import Button from 'components/elements/button';
import { CarouselWrapper, Indicator } from 'components/base/Carousel/index';

const hoverState = `
  &:hover {
    cursor: pointer;
  }
`;

export const CloseButton = styled(Button)`
  padding: 2.1875rem 2.1875rem 0;
  ${hoverState};
`;

export const NextButton = styled('button')`
  background-color: #0bd6a7;
  width: 178px;
  height: 43px;
  color: ${({ theme }): string => theme.White};
  border-radius: 4px;
  ${hoverState};
`;

export const Figure = styled('figure')`
  margin: 0;
`;

export const Content = styled('div')`
  ${CarouselWrapper} {
    padding-bottom: 0;
  }
  ${NextButton} {
    position: absolute;
    top: 360px;
    left: 5.375em;
  }
  .control-dots {
    position: absolute;
    top: 290px;
    left: 5em;
    height: 22px;
    text-align: left;
  }

  ${Indicator} {
    width: 11px;
    height: 11px;
    border-radius: 7px;
    background-color: #e0e0e0;

    &.active {
      background-color: #0bd6a7;
    }
    ${hoverState};
  }
`;

export const BoxWrapper = styled(Box)`
  grid-gap: 0 10em;
  grid-template-columns: 1fr 2fr;
  grid-gap: 0 7em;
`;
